import {FulltextSearch} from '@/api/meta/filters';
import {autoImplement} from '@/util';
import moment from 'moment';

export interface ApiContact {
  Anrede: string;
  Briefanrede: string;
  Vorname: string | null;
  Nachname: string;
  Abteilung: string;
  Position: string;
  AufgabenGebiet: string;
  AustrittDatum: string | null;
  LangName1: string;
  Telefon1: string;
  Telefon2: string;
  Plz: string;
  Ort: string;
  Strasse: string;
  Email: string | null;
  Homepage: string;
  KundenNr: number;
  Nummer: number;
  AnsprechpartnerNr: number;
  Info1: string | null;
  Info2: string | null;
  Ausgeschieden: boolean;
}

export interface ApiContactSubmitData{
  Nachname: string;
  Vorname: string | null;
  Position: string;
  Abteilung: string;
  AufgabenGebiet: string;
  AustrittDatum: string | null;
  Anrede: string;
  Titel: string | null;
  Briefanrede: string;
  Name1: string;
  Name2: string | null;
  Name3: string;
  Strasse: string;
  NAT: string;
  Plz: string | null;
  Ort: string;
  Postfach: string | null;
  PostfachPlz: number | null;
  PostfachOrt: string | null;
  Telefon1: string;
  Telefon2: string;
  Telefax: string;
  Email: string | null;
  Homepage: string;
  Info1: string | null;
  Info2: string | null;
}

export interface ContactFilters {
  KundenNr?: number;
  Fulltext$Fulltext: FulltextSearch;
  Ausgeschieden?: boolean;
}

export interface DetailContactFilters {
  KundenNr?: number;
  AnsprechpartnerNr?: number;
}

export default class Contact extends autoImplement<ApiContact>() {
  static fromApi(apiContact: ApiContact): Contact {
    return new Contact(apiContact);
  }

  get fullName() {
    const nameData = [this.Nachname];
    if (this.Vorname) nameData.push(this.Vorname);

    return nameData.join(', ');
  }

  get austrittsDatumParsed() {
    return this.AustrittDatum ? moment(this.AustrittDatum) : null;
  }

  get color() {
    return this.Ausgeschieden ? 'error' : 'green';
  }

  get icon() {
    return this.Ausgeschieden ? null : 'mdi-check';
  }
}
